const { Criteria } = Shopware.Data;

export default {
    template: `
<sw-page class="riccardo-compliance-list">
    <template #smart-bar-header><h2>Pflichtangaben <span v-if="!isLoading">({{ total }})</span></h2></template>
    <template #smart-bar-actions>
        <sw-button variant="primary" :router-link="{ name: 'riccardo.compliance.create' }">Profil anlegen</sw-button>
    </template>
    <template #content>
        <sw-entity-listing v-if="profiles" :items="profiles" :repository="repository" :columns="columns" :is-loading="isLoading"
                           :show-selection="false" detail-route="riccardo.compliance.detail" @update-records="getList">
            <template #column-active="{ item }">
                <sw-icon :name="item.active ? 'regular-checkmark-xs' : 'regular-times-s'" :color="item.active ? '#37d046' : '#de294c'" small />
            </template>
            <template #column-signalWord="{ item }">{{ item.signalWord === 'danger' ? 'Gefahr' : (item.signalWord === 'warning' ? 'Achtung' : '–') }}</template>
            <template #column-pictograms="{ item }">{{ (item.pictograms || []).join(', ') || '–' }}</template>
            <template #column-assignment="{ item }">
                {{ (item.products || []).length }} Artikel · {{ (item.categories || []).length }} Kategorien
            </template>
            <template #column-sds="{ item }">{{ item.sdsMediaId ? 'ja' : '–' }}</template>
        </sw-entity-listing>
    </template>
</sw-page>`,

    inject: ['repositoryFactory'],

    data() {
        return { profiles: null, isLoading: false, total: 0 };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('riccardo_compliance_profile');
        },
        columns() {
            return [
                { property: 'active', label: 'Aktiv', align: 'center', width: '80px' },
                { property: 'name', label: 'Profil', primary: true, routerLink: 'riccardo.compliance.detail' },
                { property: 'signalWord', label: 'Signalwort' },
                { property: 'pictograms', label: 'Piktogramme' },
                { property: 'assignment', label: 'Zuweisung', sortable: false },
                { property: 'sds', label: 'Sicherheitsdatenblatt', sortable: false },
                { property: 'priority', label: 'Priorität', align: 'right' },
            ];
        },
    },

    created() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;
            const criteria = new Criteria(1, 50);
            criteria.addAssociation('products');
            criteria.addAssociation('categories');
            criteria.addSorting(Criteria.sort('priority', 'DESC'));
            criteria.addSorting(Criteria.sort('name', 'ASC'));
            return this.repository.search(criteria).then((result) => {
                this.profiles = result;
                this.total = result.total;
            }).finally(() => { this.isLoading = false; });
        },
    },
};
